import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";
const { colors } = constants;

const { mediaQuery: breakpoint } = mediaQueryStyles;
const { Breakpoints } = constants.breakpoints;
const { md } = Breakpoints;

export const container: CSSObject = {
  backgroundColor: colors.ui.neutral[25],
  display: "flex",
  flexDirection: "column",
  letterSpacing: 1,
  minHeight: 0,
  height: "100vh",
  overflowY: "auto",
};

export const header: CSSObject = {
  backgroundColor: colors.ui.core[500],
  borderRadius: 3,
  cursor: "pointer",
  margin: "5px 5px 10px",
  color: colors.ui.white[700],
  fontWeight: 700,
  fontSize: 16,
  lineHeight: "150%",
  letterSpacing: 0,
  textDecorationStyle: "solid",
  padding: 10,

  [breakpoint.upTo(md)]: {
    backgroundColor: "transparent",
    color: colors.ui.black[100],

    ":hover": {
      background: colors.ui.neutral[50],
    },
  },
};

export const treeContainer: CSSObject = {
  padding: "0 10px",
};

export const treeItemCss = (isFocused: boolean): CSSObject => ({
  animation: "show 600ms 100ms cubic-bezier(0.38, 0.97, 0.56, 0.76) forwards;",
  backgroundColor: isFocused ? colors.ui.core[25] : "transparent",
  border: "none",
  borderRadius: 2,
  display: "flex",
  padding: 0,
  color: colors.ui.black[100],
  marginBottom: 8,
  width: "100%",

  ":hover": {
    background: isFocused ? colors.ui.core[25] : colors.ui.neutral[50],
  },
});

export const treeItemText: CSSObject = {
  color: colors.ui.neutral[700],
  fontFamily: "Circular",
  fontWeight: 400,
  fontSize: 14,
  letterSpacing: 0,
  lineHeight: "171%",
  padding: "5px",
  verticalAlign: "middle",
  textAlign: "left",
  display: "flex",
};

export const chevron: CSSObject = {
  verticalAlign: "middle",
  paddingLeft: 4,
  paddingRight: 8,
  width: 28,
};

export const lineItemIndicatorCss = (isFocused: boolean): CSSObject => ({
  background: isFocused ? colors.ui.core[500] : colors.ui.neutral[100],
  borderRadius: "2px",
  height: "calc(100% - 8px)",
  position: "absolute",
  top: "4px",
  width: "4px",
});
